(ns humbleai.belt.transit
  "Transit as the browser speaks it to the platform: instants go over the wire
   tagged \"inst\" and come back as `goog.date.UtcDateTime`."
  (:require
   [cognitect.transit :as t]
   [com.rpl.specter :as sp])
  (:import
   (goog.date DateTime UtcDateTime)))

(defn browser-offset-str
  ([minutes]
   (if (= 0 minutes)
     "Z"
     (let [sign (if (pos-int? minutes) "-" "+")
           hours (abs (quot minutes 60))
           minutes (abs (mod minutes 60))]
       (str sign hours ":" (.padStart (str minutes) 2 "0"))))))

(def read-handlers
  {"inst" (t/read-handler UtcDateTime/fromIsoString)})

(def write-handlers
  {;; A native js/Date (what the date-picker and `js/Date.` produce) matches
   ;; neither goog.date type below, so without this it never gets the "inst"
   ;; tag the server's reader needs — it lands server-side as a bare ISO string
   ;; and Datomic rejects it for `:inst` attributes (e.g. `:task/deadline-at`).
   js/Date
   (t/write-handler "inst" #(.toISOString ^js %))

   DateTime
   ;; The browser's offset from UTC, in minutes: -60 in CET.
   (t/write-handler "inst" #(str % (browser-offset-str (.getTimezoneOffset (js/Date.)))))

   UtcDateTime
   (t/write-handler "inst" #(str % "Z"))})

(defn reader []
  (t/reader :json {:handlers read-handlers}))

(defn writer []
  (t/writer :json {:handlers write-handlers}))

(defn read [t]
  (t/read (reader) t))

(defn write [o]
  (t/write (writer) o))

(when goog.DEBUG
  (defn locate-unserializable
    "Best attempt to locate un-serializable things by transit in a data structure, including their get-in path"
    [data]
    (let [unserialiable? #(or (fn? %)) ;; maybe other types go here
          walker (sp/recursive-path
                  [] p
                  (sp/cond-path
                   sequential?
                   [sp/INDEXED-VALS
                    (sp/if-path [sp/LAST (sp/pred unserialiable?)]
                                [(sp/collect-one sp/FIRST) (sp/collect-one sp/LAST) sp/NONE]
                                [(sp/collect-one sp/FIRST) sp/LAST p])]
                   map?
                   [sp/ALL
                    (sp/if-path [sp/LAST (sp/pred unserialiable?)]
                                [(sp/collect-one sp/FIRST) (sp/collect-one sp/LAST) sp/NONE]
                                [(sp/collect-one sp/FIRST) sp/LAST p])]))
          ret (sp/select walker data)]
      (mapv (comp vec butlast) ret))))

(defn write* [o]
  (if goog.DEBUG
    (try
      (write o)
      (catch :default e
        (js/console.error "Could not write the object!" :object o :invalid-paths (locate-unserializable o))
        (throw e)))
    (write o)))
